import script from "./activty-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./activty-detail.vue?vue&type=script&lang=tsx&setup=true"

import "./activty-detail.vue?vue&type=style&index=0&id=76f86f4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f86f4c"]])

export default __exports__